(() => {
  if (window.AWGarageP2Integrity?.version) return;
  const REPLICAS='aw_garage_replicas_v1';
  const TIMELINE='aw_upgrade_timeline_v1';
  const BUILDS='aw_airsoft_saved_configurations';
  const ATELIER_URL='/pages/notre-atelier-de-preparation-de-repliques-airsoft#aw-atelier-prestations';
  const parse=(key,fallback)=>{try{return JSON.parse(localStorage.getItem(key)||'null')??fallback}catch(_){return fallback}};
  const save=(key,value)=>{try{localStorage.setItem(key,JSON.stringify(value))}catch(_){}};
  const refresh=(key)=>{try{window.dispatchEvent(new StorageEvent('storage',{key}))}catch(_){}};
  const track=(name,payload={})=>{try{window.AWAnalytics?.track?.(name,payload)}catch(_){}};

  const decorateMaintenance=()=>{
    const replicas=parse(REPLICAS,[]);
    const timeline=parse(TIMELINE,[]);
    document.querySelectorAll('[data-aw-garage-p2] [data-aw-maintenance-card]').forEach((card)=>{
      const replicaId=String(card.dataset.awMaintenanceCard||'');
      const replica=replicas.find((item)=>String(item?.id||'')===replicaId);
      const buttons=card.querySelector('.aw-p2-maintenance-buttons');
      if(!replica||!buttons)return;
      const state=window.AWGarageP2?.maintenanceState?.(replica,timeline);
      if(!state||state.status==='disabled')return;

      if(!buttons.querySelector('[data-aw-maintenance-disable]')){
        const disable=document.createElement('button');
        disable.type='button';
        disable.className='button button--secondary';
        disable.dataset.awMaintenanceDisable=replicaId;
        disable.textContent='Désactiver le suivi';
        buttons.appendChild(disable);
      }

      if(['soon','overdue'].includes(state.status)&&!buttons.querySelector('[data-aw-maintenance-atelier]')){
        const atelier=document.createElement('a');
        atelier.className='button button--secondary';
        atelier.href=ATELIER_URL;
        atelier.dataset.awMaintenanceAtelier=replicaId;
        atelier.dataset.awMaintenanceStatus=state.status;
        atelier.textContent='Consulter l’Atelier';
        atelier.setAttribute('aria-label',`Consulter l’Atelier pour ${replica.nickname||replica.model||'cet équipement'}`);
        buttons.appendChild(atelier);
      }
    });
  };

  const enforce=()=>{
    const replicas=parse(REPLICAS,[]);
    let timeline=parse(TIMELINE,[]);
    let changed=false;
    const seen=new Set();
    timeline=timeline.filter((event)=>{
      if(event?.type!=='certification')return true;
      const key=[event.replicaId||'',event.certificationId||'',event.date||''].join('|');
      if(seen.has(key)){changed=true;return false}
      seen.add(key);return true;
    });
    replicas.forEach((replica)=>{
      if(replica?.certification?.status!=='certified')return;
      const certifiedAt=new Date(replica.certification.certifiedAt||0);
      if(Number.isNaN(certifiedAt.getTime()))return;
      const laterChange=timeline.some((event)=>event.replicaId===replica.id&&event.type==='upgrade'&&new Date(`${event.date||event.createdAt||''}`.length<=10?`${event.date||event.createdAt}T23:59:59`:event.date||event.createdAt)>certifiedAt);
      if(!laterChange)return;
      replica.certification={...replica.certification,status:'review'};
      const already=timeline.some((event)=>event.replicaId===replica.id&&event.type==='certification_review');
      if(!already)timeline.unshift({id:`review_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,7)}`,replicaId:replica.id,type:'certification_review',title:'Certification à revalider',notes:'Une modification a été déclarée après la certification Atelier.',date:new Date().toISOString().slice(0,10),source:'system',createdAt:new Date().toISOString()});
      changed=true;
    });
    if(changed){save(REPLICAS,replicas);save(TIMELINE,timeline);refresh(REPLICAS)}
    window.setTimeout(()=>{
      document.querySelectorAll('[data-aw-garage-p2] [data-replica-id]').forEach((card)=>{
        const replica=replicas.find((item)=>item.id===card.dataset.replicaId);
        if(replica?.certification?.status!=='review')return;
        const badge=card.querySelector('.aw-p2-badge');
        if(badge){badge.textContent='Certification à revalider';badge.classList.remove('aw-p2-badge--certified');badge.classList.add('aw-p2-badge--verified')}
      });
      decorateMaintenance();
    },0);
  };

  document.addEventListener('click',(event)=>{
    const disable=event.target.closest?.('[data-aw-maintenance-disable]');
    if(disable){
      const replicaId=String(disable.dataset.awMaintenanceDisable||'');
      const replicas=parse(REPLICAS,[]);
      const index=replicas.findIndex((item)=>String(item?.id||'')===replicaId);
      if(index<0)return;
      replicas[index]={...replicas[index],maintenanceMonths:0,maintenanceDueDate:'',updatedAt:new Date().toISOString()};
      save(REPLICAS,replicas);
      refresh(REPLICAS);
      try{window.dispatchEvent(new CustomEvent('aw:p2-garage-updated',{detail:window.AWGarageP2?.getState?.()||{}}))}catch(_){}
      track('p2_maintenance_tracking_disabled',{replica_id:replicaId,timeline_preserved:true});
      return;
    }
    const atelier=event.target.closest?.('[data-aw-maintenance-atelier]');
    if(atelier){
      track('p2_maintenance_atelier_opened',{replica_id:String(atelier.dataset.awMaintenanceAtelier||''),maintenance_status:String(atelier.dataset.awMaintenanceStatus||'')});
    }
  },true);

  document.addEventListener('change',async(event)=>{
    const input=event.target.closest?.('[data-aw-garage-import]');
    const file=input?.files?.[0];
    if(!file)return;
    try{
      const payload=JSON.parse(await file.text());
      if(!Array.isArray(payload.builds))return;
      const current=parse(BUILDS,[]);
      const map=new Map(current.map((item)=>[item.id,item]));
      payload.builds.forEach((item)=>item?.id&&map.set(item.id,item));
      save(BUILDS,[...map.values()]);
      refresh(BUILDS);
    }catch(_){}
  },true);

  window.addEventListener('aw:p2-garage-updated',enforce);
  window.addEventListener('aw:p2-workshop-certification',()=>window.setTimeout(enforce,0));
  const start=()=>enforce();
  window.AWGarageP2Integrity={version:'1.1.0',enforce,decorateMaintenance};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();